import FacebookIcon from '@uniiverse/library/assets/icons/facebook-circle.svg'
import YoutubeIcon from '@uniiverse/library/assets/icons/youtube.svg'
import ItunesIcon from '@uniiverse/library/assets/icons/itunes.svg'
import SpotifyIcon from '@uniiverse/library/assets/icons/spotify.svg'
import TwitterIcon from '@uniiverse/library/assets/icons/twitter-x.svg'
import SoundcloudIcon from '@uniiverse/library/assets/icons/soundcloud.svg'
import TidalIcon from '@uniiverse/library/assets/icons/tidal.svg'
import InstagramIcon from '@uniiverse/library/assets/icons/instagram.svg'

export const DESCRIPTION_ID = 'Description'
export const ACCESSIBILITY_DESCRIPTION_ID = 'Accessibility Details'
export const DATE_AND_TIME_ID = 'Date and time'
export const LOCATION_ID = 'Location'
export const ATTRACTIONS_ID = 'Attractions'
export const HOST_ID = 'Host'
export const PHOTOS_ID = 'Photos'
export const INTERESTS_ID = 'Interests'
export const AVAILABILITY_ID = 'Availability'

export const MOBILE_WIDGET_HEIGHT = '800px'
export const DESKTOP_WIDGET_HEIGHT = '600px'

const DATE_BOX_MOBILE_LIMIT = 6
const DATE_BOX_DESKTOP_TABLET_LIMIT = 8
export const MAX_DATE_BOXES_TO_SHOW = window.innerWidth <= 751 ? DATE_BOX_MOBILE_LIMIT : DATE_BOX_DESKTOP_TABLET_LIMIT

const IMAGES_MOBILE_LIMIT = 3
const IMAGES_DESKTOP_TABLET_LIMIT = 4
export const MAX_IMAGES_TO_SHOW = window.innerWidth <= 751 ? IMAGES_MOBILE_LIMIT : IMAGES_DESKTOP_TABLET_LIMIT

export const MAX_ATTRACTIONS_TO_DISPLAY = 10

export const ATTRACTIONS_TITLE = {
  ALL: 'ALL',
  MAIN: 'MAIN',
  HEADLINERS: 'HEADLINERS',
  LINEUP: 'LINEUP',
}

// If you would like to make changes here please make sure you have the same changes on HOST project
export const DEFAULT_SECTION_TITLES = {
  ALL: 'sectionNameAttractions',
  HEADLINERS: 'sectionNameHeadliners',
  LINEUP: 'sectionNameLineup',
  MAIN: 'sectionNameAttractions',
}

export const SOCIAL_NETWORKS = {
  facebook: { path: 'https://www.facebook.com/', Icon: FacebookIcon },
  instagram: { path: 'https://www.instagram.com/', Icon: InstagramIcon, params: { width: '19px', height: '19px' } },
  youtube: { path: 'https://www.youtube.com/', Icon: YoutubeIcon },
  itunes: { path: 'https://itunes.apple.com/artist/', Icon: ItunesIcon },
  spotify: { path: 'https://open.spotify.com/artist/', Icon: SpotifyIcon },
  twitter: { path: 'https://x.com/', Icon: TwitterIcon },
  sound_cloud: { path: 'https://soundcloud.com/', Icon: SoundcloudIcon },
  tidal: { path: 'https://tidal.com/browse/artist/', Icon: TidalIcon },
}

const ALLOWED_WIDGETS_URLS_REGEXP = [
  '(?:open.spotify.com\\/embed\\/\\S+)',
  '(?:w.soundcloud.com\\/player\\/\\S+)',
].join('')

export const ATTRACTIONS_WIDGETS_SANITIZATION_CONFIG = {
  ALLOWED_TAGS: ['iframe'],
  ALLOWED_ATTR: [
    'width',
    'height',
    'scrolling',
    'frameborder',
    'allow',
    'style',
    'allowfullscreen',
    'src',
    'loading',
  ],
  ADD_URI_SAFE_ATTR: [
    'width',
    'height',
    'scrolling',
    'frameborder',
    'allow',
    'style',
    'allowfullscreen',
    'src',
    'loading',
  ],
  ALLOWED_URI_REGEX: new RegExp([
    '^https:\\/\\/(',
    ALLOWED_WIDGETS_URLS_REGEXP,
    ')$',
  ].join(''), 'i'),
}

export const DATE_DISPLAY_OPTIONS = {
  full: 'FULL',
  startTimeOnly: 'START_TIME_ONLY',
  hideEventTime: 'HIDE_EVENT_TIME',
}

export const VIDEO_URLS_REGEXP = new RegExp([
  '^https:\\/\\/(?:www\\.',
  '(youtube|youtube-nocookie)\\.com\\/embed\\/\\S+',
  '|(?:player\\.vimeo\\.com\\/video\\/\\S+)',
  '|(?:vimeo\\.com*\\S+)',
  '|(?:player\\.twitch\\.tv\\/\\S+)',
  '|(?:www\\.twitch\\.tv\\/videos\\/\\S+)',
  '|(?:www\\.dailymotion.com\\/embed\\/video\\/\\S+)',
  '|(?:open.spotify.com\\/embed\\/\\S+)',
  ')$',
].join(''), 'i')

export const DESCRIPTION_SANITIZATION_CONFIG = {
  ALLOWED_TAGS: [
    'p',
    'a',
    'hr',
    'em',
    'strong',
    'u',
    'blockquote',
    'pre',
    'span',
    'del',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'br',
    'figure',
    'img',
    'ul',
    'ol',
    'li',
    'table',
    'tbody',
    'tr',
    'td',
  ],
  ADD_TAGS: ['iframe'],
  ADD_URI_SAFE_ATTR: [
    'frameborder',
    'allow',
    'allowfullscreen',
    'allowtransparency',
    'width',
    'height',
    'scrolling',
    'style',
    'src',
    'href',
    'rel',
  ],
  ADD_ATTR: [
    'frameborder',
    'allow',
    'allowfullscreen',
    'allowtransparency',
    'src',
    'href',
    'style',
    'scrolling',
  ],
  ALLOWED_URI_REGEXP: VIDEO_URLS_REGEXP,
  ALLOW_DATA_ATTR: false,
}
